import { useFlag } from '@calendly/feature-check-react';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { LocationIcon } from 'components/core/location_icon';
import { getLabelForKindWithNotetaker } from '../utils';
const containerCss = "cfg0h98";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const nameCss = "n1lzspeo";
const Name = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(nameCss, props.className)} />;
});
const newIconWrapperCss = "n10ipb88";
const NewIconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(newIconWrapperCss, props.className)} />;
});
const IconWrapper = ({
  children,
  ...props
}) => <NewIconWrapper {...props}>
    {children}
  </NewIconWrapper>;
export const PrimaryInfo = ({
  kind,
  notetakerEnabledForEt = false
}) => {
  const hasMsTeamsFlag = useFlag('ms_teams_notetaker');
  return <Container>
      <IconWrapper kind={kind}>
        <LocationIcon kind={kind} />
      </IconWrapper>
      <Name>
        {getLabelForKindWithNotetaker({
        kind,
        isNotetakerEnabledForEt: notetakerEnabledForEt,
        hasMsTeamsFlag
      })}
      </Name>
    </Container>;
};

require("./primary_info.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./primary_info.js");